import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onboardingHints } from '../../../constants';
import Dialog from '../../Dialog/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material';
import config from 'config';
import { customSizes } from '../../../assets/styles/themes/tokens';

interface NewFiltersFeedbackDialogProps {
  shouldRender: boolean;
}

const storageId = onboardingHints.newFiltersFeedback;

const NewFiltersFeedbackDialog : React.FC<NewFiltersFeedbackDialogProps>= ({ shouldRender }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('mobile'));

  const isSeen = localStorage.getItem(storageId) === 'seen';
  const isClosed = localStorage.getItem(storageId) === 'closed';
  const isRemindLater = sessionStorage.getItem(storageId) === 'remindLater';

  const [visible, setVisible] = useState(
    shouldRender &&
    !isClosed &&
    !isRemindLater &&
    !isSeen
  );

  useEffect(() => {
    if (visible && !isSeen) {
      localStorage.setItem(storageId, 'seen');
    }
  }, [visible]);

  useEffect(() => {
    setVisible(
      shouldRender &&
      !isClosed &&
      !isSeen &&
      !isRemindLater
    );
  }, [isClosed, isRemindLater, shouldRender]);

  const position: 'right-bottom' | 'center' = isMobile ? 'center' : 'right-bottom';

  return (
    <Dialog
      open={visible}
      onClose={() => {
        localStorage.setItem(storageId, 'closed');
        setVisible(false);
      }}
      title={t('How do you like the new design?')}
      primaryCta={{
        label: t('Give feedback'),
        onClick: () => {
          window.open(config.newFiltersFeedbackModal.url, '_blank');
          localStorage.setItem(storageId, 'closed');
          setVisible(false);
        },
      }}
      secondaryCta={{
        label: t('Remind me later'),
        onClick: () => {
          setVisible(false);
          sessionStorage.setItem(storageId, 'remindLater');
          localStorage.removeItem(storageId);
        },
      }}
      htmlBody={null}
      position={position}
      desktopWidth={customSizes.filtersFeedbackDialog.desktopWidth}
    />);
};

export default NewFiltersFeedbackDialog;
